import { Component, OnInit, Input, Inject } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { AuthUser } from '../../../core/auth/auth-frame/auth-user.model';
import { Observable, merge, fromEvent } from 'rxjs';
import { Router } from '@angular/router';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { detailFromBreadcrumb, normalizePath } from '@app/shared/utils';

@Component({
  selector: 'app-search-result-item',
  templateUrl: './search-result-item.component.html',
  styleUrls: ['./search-result-item.component.css']
})
export class SearchResultItemComponent implements OnInit {

  @Input() name: string;
  @Input() title: string;
  @Input() description: string;
  @Input() isSearchBar: boolean;
  @Input() url: string;
  @Input() id: string;
  @Input() typeMenu: number;
  @Input() initialTabindex: number;

  private authUser: AuthUser;
  authSubject: Observable<AuthUser>;

  constructor(private authService: AuthService, @Inject('Window') private _window: Window, private router: Router,
    private itauUserIdleService: ItauUserIdleService, private sessionService: SessionService,
    private _sdkAnalyticsService:SdkAnalyticsService) { }

  ngOnInit() {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });

  }


  redirectPage(event) {
    let nameEvent;
    if (event && event.__proto__ && event.__proto__.constructor.name) {
      nameEvent = event.__proto__.constructor.name;
    }
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      nameEvent = event.type
    }

    if (nameEvent && (nameEvent === 'MouseEvent' || nameEvent === 'click' || nameEvent === 'PointerEvent' || nameEvent === 'KeyboardEvent') && this.typeMenu !== 5) {
      this.itauUserIdleService.stopWatching();
      this.sessionService.updateSession().subscribe(() => { });
      var sUrl = this.authUser.serverEstatisticas + '?xyz=0';

      if(this.description && this.router && this.router.url){
        this._sdkAnalyticsService.trackEvent( 'click', {
          custom_path: normalizePath(this.router.url),
          implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
          detail: detailFromBreadcrumb(this.description,'resultado-busca:')
        });
      }

      try {
        let userType = this.authUser.tipo == 1 ? "A" : "C"
        sUrl += this.getQueryString(this.authUser.token, this.authUser.idSessao, this.authUser.idConexao, this.authUser.gestor, this.authUser.name, userType);
        sUrl += this.getQueryStringFunction(this.id);
        var windowOK4 = this._window.open(sUrl, name, 'directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5');
        this.itauUserIdleService.setCustomActivityEvents(
          merge(
            fromEvent(window, 'mousemove'),
            fromEvent(window, 'resize'),
            fromEvent(document, 'keydown'),
            fromEvent(document, 'touchstart'),
            fromEvent(document, 'touchend'),
            fromEvent(windowOK4, 'mousemove'),
            fromEvent(windowOK4, 'resize')
        ));
        this.itauUserIdleService.startWatching();
      }
      catch (ex) {
        throw ex;

      }
    }
    else {
      this.openModalContext(this.url);
    }
  }

  private openModalContext(myurl) {
    if(this.description && myurl){
      this._sdkAnalyticsService.trackEvent( 'click', {
        custom_path: normalizePath(myurl),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: detailFromBreadcrumb(this.description,'resultado-busca:')
      });
    }
    this.router.navigate([myurl]);
  }

  private getQueryStringFunction(codFunction) {
    try {
      return '&iDFuncao=' + (-1 * codFunction);
    }
    catch (ex) {
      throw ex;
    }
  }

  private getQueryString(token, idConnection, idSession, sGestor, nameUser, userType) {
    try {
      return '&sessao=' + token +
        '&id=' + idConnection +
        '&idsessao=' + idSession +
        '&gestor=' + sGestor +
        '&nomeUsu=' + nameUser +
        '&tipousu=' + userType;
    }
    catch (ex) {
      throw ex;
    }
  }
}
